// Import the React and QrReader modules
import React, { Component } from "react";
import BackBar from "../components/backBar";

import Html5QrcodePlugin from "../components/Html5QrcodePlugin";

// Define a React component called QRScanner
class QRScanner extends Component {
  constructor(props) {
    super(props);
    // Initialize the component's state with two properties: scanning and result
    this.state = {
      scanning: false,
      result: "",
      videoSource: null,
    };
    // Bind several methods to the component instance
    this.handleScan = this.handleScan.bind(this);
    this.handleError = this.handleError.bind(this);
    this.toggleScanning = this.toggleScanning.bind(this);
    this.extractBookingId = this.extractBookingId.bind(this);
    this.onNewScanResult = this.onNewScanResult.bind(this);
  }

  componentDidMount() {
    // const getBackCamera = async () => {
    //   console.log(window?.navigator?.mediaDevices);
    //   try {
    //     const mediaDevices = navigator.mediaDevices;
    //     console.log({ mediaDevices });
    //     const deviceId = await mediaDevices.getUserMedia({
    //       audio: false,
    //       video: true,
    //       facingMode: { exact: "front" },
    //     });
    //     const devices = await mediaDevices.enumerateDevices();
    //     this.setState({ videoSource: deviceId });
    //     console.log(devices);
    //     const backCamera = devices.find(
    //       (device) =>
    //         device.kind === "videoinput" && device.label.includes("back")
    //     );
    //     if (backCamera) {
    //       //setVideoSource(backCamera.deviceId);
    //       this.setState({ videoSource: backCamera.deviceId });
    //     } else {
    //       //console.error('Back camera not found.');
    //       const frontCamera = devices.find(
    //         (device) => device.kind === "videoinput"
    //       );
    //       this.setState({ videoSource: frontCamera.deviceId });
    //     }
    //   } catch (error) {
    //     console.error("Error accessing camera devices:", error);
    //   }
    // };
    // getBackCamera();
  }

  // A method called when a QR code is successfully scanned
  handleScan(data) {
    console.log({ data });
    if (data) {
      // Extract the booking ID from the scanned data using the extractBookingId method
      let bookingId = this.extractBookingId(data);
      // Update the component's state with the booking ID
      this.setState({ result: bookingId });

      // Navigate the user to a search page with the booking ID as a query parameter using the react-router-dom package
      this.props.history.push(`search?bookingId=${bookingId}&checkIn=false`);
    }
  }

  // A method that extracts the booking ID from a URL-encoded string
  extractBookingId(url) {
    // Define a regular expression to match the booking ID
    const regex = /bookingId=([A-Z,a-z,0-9]+)/;
    // Attempt to match the regular expression against the URL-encoded string
    const match = url.match(regex);
    // If a match is found, return the booking ID (the first capturing group of the regex match)
    if (match) {
      return match[1];
    } else {
      // Otherwise, return null
      return null;
    }
  }

  // A method called when an error occurs during the scanning process
  handleError(err) {
    // Log the error to the console
    console.error(err);
    // Update the component's state to stop scanning
    this.setState({ scanning: false });
  }

  // A method called when the user toggles the scanning on or off
  toggleScanning() {
    // Update the component's state to toggle the scanning
    this.setState({ scanning: !this.state.scanning });
  }

  onNewScanResult(decodedText, decodedResult) {
    // handle decoded results here
    this.handleScan(decodedText);
    console.log({ decodedText, decodedResult });
  }

  // The render method returns a div that contains a QrReader component
  render() {
    return (
      <div className="App">
        <BackBar title={"Scan Qr Code"} />
        <Html5QrcodePlugin
          fps={10}
          qrbox={250}
          disableFlip={false}
          qrCodeSuccessCallback={this.onNewScanResult}
        />
      </div>
    );
  }
}

// Export the QRScanner component as the default export of this module
export default QRScanner;
